import { Route, Routes, useNavigate }  from 'react-router-dom';
import LandingPage from './pages/LandingPage/LandingPage.jsx';
import ErrorPage from './pages/ErrorPage/ErrorPage.jsx';
import './App.css';
import MaintenancePage from './pages/MaintenancePage/MaintenancePage.jsx';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LandingPage/>} />
        {/* <Route path="/" element={<MaintenancePage/>} /> */}
        <Route path="*" element={<ErrorPage/>} />
      </Routes>
    </div>
  );
}

export default App;
